// UserDetailsByAdmin.js

import React, { useState, useEffect } from 'react';
import Navbar from 'components/Navbars/AdminNavbar';
import Footer from 'components/Footers/Footer';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import BASE_URL from 'components/BaseUrl/apiConfig';
import Swal from 'sweetalert2';

const UserDetailsByAdmin = ({ location }) => {
  const history = useHistory();
  const [users, setUsers] = useState([]);

  useEffect(() => {
    // Check if user is not logged in (localStorage is empty)
    if (!localStorage.getItem("userData")) {
      // Redirect to the login page
      history.push("/login");
    }
  }, [history]);

  const { user } = location.state || {};
  const { subuser } = location.state || {};


  useEffect(() => {
    if (user) {
      fetch(`${BASE_URL}/api/SubUser/GetAllSubUsersByGroupId?userId=${user.userId}`)
        .then(response => response.json())
        .then(data => {
          if (Array.isArray(data)) {
            setUsers(data);
          } else {
            console.error('Invalid response format - expected an array:', data);
          }
        })
        .catch(error => console.error('Error fetching subuser data:', error));
    }
  }, [user]);


  const formatPayDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const viewUser = (user) => {
    // Use the history object to navigate to the "/viewUser" page with the user data
    history.push({
      pathname: `/viewUser`,
      state: { user },
    });
  };

  const navigateEditUser = (user1) => {
    history.push({
      pathname: `/updateSubUserbyAdmin`,
      state: { subuser: user1 },
    });
  };



  const deleteSubUser = (userId, userName) => {
    // Show a SweetAlert confirmation before deleting
    Swal.fire({
      title: 'Confirmation',
      text: `Are you sure want to delete ${userName}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        // User clicked "Yes, delete it!" - Perform the delete API call
        fetch(`${BASE_URL}/api/SubUser/DeleteSubUser?userId=${userId}`, {
          method: 'Post',
        })
          .then(response => response.json())
          .then(data => {
            if (data.success) {
              // Handle successful delete (remove the user from the state, show success message, etc.)
              setUsers(prevUsers => prevUsers.filter(user => user.userId !== userId));
              Swal.fire('Deleted!', 'User has been deleted successfully.', 'success');
            } else {
              // Handle delete failure (show error message, etc.)
              Swal.fire('Error!', 'User deletion failed.', 'error');
            }
          })
          .catch(error => console.error('Error deleting user:', error));
      }
    });
  };



  const handleVerificationButtonClick = (userId,text) => {
    Swal.fire({
        title: 'Confirmation',
        text: `Are you sure want to ${text}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes',
    }).then((result) => {
        if (result.isConfirmed) {
            // User clicked "Yes, delete it!" - Perform the delete API call 
            fetch(`${BASE_URL}/api/Users/UserVerifybyAdmin?userid=${userId}`, {
                method: 'POST',
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(data => {
                    if (data.success) {
                        Swal.fire('Success!', `User ${text} successfully.`, 'success');
                        fetch(`${BASE_URL}/api/SubUser/GetAllSubUsersByGroupId?userId=${user.userId}`)
                        .then(response => response.json())
                        .then(data => setUsers(data))
                        .catch(error => console.error('Error fetching data:', error));
                    } else {
                        // Handle verification failure (show error message, etc.)
                        Swal.fire('Error!', `User ${text} failed.`, 'error');
                    }
                })
                .catch(error => {
                    console.error(`Error ${text} user:`, error);
                    // Handle network errors or API call issues
                    Swal.fire('Error!', 'Something went wrong. Please try again.', 'error');
                });
        }
    });
};




  return (
    <>
      <Navbar />
      <div className='cust-div'>
        <div className="container mx-auto mt-8 p-4">
          <h2 className="text-2xl font-bold mb-4">User Details</h2>
          {user ? (
            <div>
              <p>
                <strong>Full Name:</strong> {user.fullName}
              </p>
              <p>
                <strong>User Name:</strong> {user.userName}
              </p>
              <p>
                <strong>Email Address:</strong> {user.emailId}
              </p>
              {/* Add other user details as needed */}
            </div>
          ) : (
            <p>No user data available.</p>
          )}
          <button
            type="button"
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 mt-4 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
            onClick={() => history.goBack()}
          >
            Back Go to Users
          </button>

          <h2 className="text-2xl font-bold mb-4">Sub Users of {user.fullName}</h2>

          <div className="overflow-x-auto">
            <table className="w-full min-w-full ">
              <tbody>
                <tr className="border-b bg-lightBlue-500 text-white">
                  <td className="cell py-2 px-4 font-bold">Full Name</td>
                  <td className="cell py-2 px-4 font-bold">User Name</td>
                  <td className="cell py-2 px-4 font-bold">Email</td>
                  <td className="cell py-2 px-4 font-bold">Last Login</td>
                  <td className="cell py-2 px-4 font-bold">Status</td>
                  <td className="cell py-2 px-4 font-bold">Actions</td>
                </tr>

                {users && users.length > 0 ? (
                  users.map((user1) => (
                    <tr key={user1.userId} className="hover:bg-gray-100 border-b">
                      <td className="cell py-2 px-4">{user1.fullName}</td>
                      <td className="cell py-2 px-4">{user1.userName}</td>
                      <td className="cell py-2 px-4">{user1.emailId}</td>
                      <td className="cell py-2 px-4">{formatPayDate(user1.lastLogin)}</td>
                      <td className="cell py-2 px-4">
                        <button
                          className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs px-2 py-1 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
                          type="button"
                         onClick={() => handleVerificationButtonClick(user1.userId, user1.isVerified === 1 ? 'Active' : 'Deactive')}
                        >
                          {user1.isVerified === 1 ? 'Deactive' : 'Active'}
                        </button>
                      </td>

                      <td className="cell py-2 px-4 flex items-center">
                        <img
                          title='Edit'
                          src={require("assets/img/Editicon.png")}
                          alt="Edit"
                          className="mr-2 cursor-pointer"
                          style={{ width: '20px' }}
                          onClick={() => navigateEditUser(user1)}
                        />
                        <img
                          title='Delete'
                          src={require("assets/img/deleteicon.png")}
                          alt="Delete"
                          className="cursor-pointer"
                          style={{ width: '20px' }}
                          //onClick={() => deleteUser(user.userId, user.userName)}
                          onClick={() => deleteSubUser(user1.userId, user1.userName)}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="cell py-2 px-4 " style={{ textAlign: 'center' }} colSpan="6">Sub user not found.</td>
                  </tr>
                )}
              </tbody>
            </table>

          </div>



        </div>


      </div>
      <Footer />
    </>
  );
};

export default UserDetailsByAdmin;
